import { render, staticRenderFns } from "./detectionList.vue?vue&type=template&id=234a7353&scoped=true"
import script from "./detectionList.vue?vue&type=script&lang=js"
export * from "./detectionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234a7353",
  null
  
)

export default component.exports